import Navigation from "@/components/Navigation";

export const InfoPage = ({ eyebrow, title, testId, children }) => (
  <div className="min-h-screen bg-crew-black">
    <Navigation userType="public" />
    <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20" data-testid={testId}>
      <article className="max-w-3xl">
        <p className="text-crew-yellow text-xs sm:text-sm font-bold uppercase tracking-[0.25em] mb-4">{eyebrow}</p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white uppercase tracking-tighter mb-10 leading-none">
          {title}
        </h1>
        <div className="space-y-6 text-zinc-300 text-sm sm:text-base leading-relaxed">{children}</div>
      </article>
    </main>
  </div>
);
